<template>
  <Modal :visible="$store.state.showMissionPopup" @hide="onCancel" :back-drop="false">
    <div class="v-layout" style="position: relative;">
      <div class="greeting-tooltip v-layout align-items-center">
        <tool-tip font-style="font-size: 14px!important; padding: 3px 10px;" :label="$t('common.mission_popup_greeting')" />
      </div>
      <div class="header">
        <label class="lbl_default3">{{$cookies.get('member_name')}}님! 안녕하세요?</label>
        <label style="font-size:2em;position: absolute; right: 20px; top: 10px;" @click="onCancel">&times;</label>
      </div>
      <div class="v-layout content">
        <div class="tabs h-layout w100 justify-between">
          <div class="tab" v-bind:class="{ active: activeTab == $c.MISSION_TAB.MISSION_TO_D0 }" @click="onChooseTab($c.MISSION_TAB.MISSION_TO_D0)">
            <label class="lbl_default6_1">{{ $t('mission.mission_to_do') }}</label>
          </div>
<!--          <div class="tab" v-bind:class="{ active: activeTab == $c.MISSION_TAB.OUR_SCHOOL_LECTURE }" @click="onChooseTab($c.MISSION_TAB.OUR_SCHOOL_LECTURE)">-->
<!--            <label class="lbl_default6_1">{{ $t('mission.our_school_lect') }}</label>-->
<!--          </div>-->
          <div class="tab" v-if="todayQuestList.length > 0" v-bind:class="{ active: activeTab == $c.MISSION_TAB.TODAY_QUEST }" @click="onChooseTab($c.MISSION_TAB.TODAY_QUEST)">
            <label class="lbl_default6_1">{{ $t('mission.today_quest') }}</label>
          </div>
        </div>
        <div class="body v-layout align-items-center">
          <div class="v-layout w100" v-if="activeTab == $c.MISSION_TAB.MISSION_TO_D0" >
            <mission-card-item
                v-for="(mission, i) in missionList"
                :key="'teacher_mission' + i"
                :mission="mission"
                :mission_type="mission.mission_type"
                @onRejectMission="onRejectMission"
                :lecture="getLectureFromMission(mission, lectureList)" />
          </div>
          <div class="v-layout" v-if="activeTab == $c.MISSION_TAB.OUR_SCHOOL_LECTURE" >
            <lecture-card-item
                v-for="(lecture, i) in ourSchoolLectureList"
                :key="'lecture' + i"
                :lecture-data="lecture" />
          </div>
          <div class="v-layout" v-if="activeTab == $c.MISSION_TAB.TODAY_QUEST" >
            <lecture-card-item
                v-for="(quest, i) in todayQuestList"
                :key="'quest' + i"
                :lecture-data="quest" />
          </div>
        </div>
        <div class="footer h-layout justify-center">
          <check-box
              v-model="isHideToday"
              @onChange="onChangeShowPopupYN"
              font-style="font-size: 14px;"
              :label="$t('mission.hide_mission_popup_today')" />
        </div>
      </div>
    </div>
  </Modal>
</template>

<script>
import ToolTip from "@/components/ToolTip";
import Modal from "@/components/Modal";
import CheckBox from "@/components/CheckBox";
import MissionCardItem from "@/components/listen_teacher/MissionCardItem";
import * as ajax from "@/utils/ajax";
import LectureCardItem from "@/components/home/LectureCardItem";

export default {
  name: "MissionPopup",
  props: {},
  components: {LectureCardItem, MissionCardItem, CheckBox, ToolTip, Modal},
  data() {
    return {
      isHideToday: this.$store.state.doNotShowMissionPopupToday,
      activeTab: this.$c.MISSION_TAB.MISSION_TO_D0,
      missionList:[],
      lectureList: [],
      ourSchoolLectureList: [],
      todayQuestList: [],
    }
  },
  mounted() {
    this.onChooseTab(this.$c.MISSION_TAB.MISSION_TO_D0);
  },
  methods: {
    onChangeShowPopupYN(state) {
      ajax.Post(this, "/api/mainpg/changeShowPopup_yn", {"isNotShow": state ? 'Y' :'N'}, function(ref, data) {
        ref.isHideToday = state;
        ref.$store.state.doNotShowMissionPopupToday = state;
      })
    },
    onCancel(){
      this.$store.state.showMissionPopup = false;
    },
    onRejectMission(mission_no) {
      this.missionList = this.missionList.filter((item, index) => {
        if (item.mission_no != mission_no)
          return item;
      })
    },
    getLectureFromMission(mission, lectureList) {
      let result = lectureList.filter((lecture, idx) => {
        if (lecture.course_no == mission.lecture_no)
          return lecture;
      });
      return result[0];
    },
    onChooseTab(idx) {
      this.activeTab = idx;
      if (idx == this.$c.MISSION_TAB.MISSION_TO_D0){
        ajax.Get(this, "/api/mission/", function(ref, data) {
          ref.missionList = data.mission;
          ref.lectureList = data.lecture
        });
      } else if(idx == this.$c.MISSION_TAB.OUR_SCHOOL_LECTURE){
        ajax.Post(this, "/api/mission/our_school_lecture", {}, function(ref, data) {
          ref.ourSchoolLectureList = data;
        });
      } else if(idx == this.$c.MISSION_TAB.TODAY_QUEST) {
        ajax.Post(this, "/api/mission/today_quest", {}, function (ref, data) {
          ref.todayQuestList = data;
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.greeting-tooltip {
  position: absolute;
  top: -28px;
  left: 0;
  right: 0;
  .padding-large {
    padding: 8px 50px;
  }
}
.header {
  background-color: $primary_color;
  color: white;
  border-radius: 10px 10px 0 0;
  padding: 15px 0;
  text-align: center;
}
.body {
  background-color: white;
  padding: 20px;
  max-height: 350px;
  min-height: 100px;
  overflow-y: auto;
}
.footer {
  border-top: solid 2px $light-grey_1;
  padding: 20px 0;
}
.content {
  background-color: white;
  border-radius: 0 0 10px 10px;
}

div.tabs {
  padding: 20px 0 0;
}
div.tabs::after {
  display: block;
  content: '';
  clear: both;
}

div.tab {
  display: flex;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid $line-secondary-color;
  justify-content: center;
  font-size: $font-base18;
  label {
    margin-top: 5px;
    margin-bottom: 5px;
  }
}

div.tab.active {
  font-weight: $font-weight500;
  color: $primary-color;
  border-bottom: 7px solid $primary-color;
}
</style>